import React, {useState} from "react";
import ThemeControls from "../../../Component/AllThemesControl";
import FormScopeDefiner from "../../../Component/Forms/FormScopeDefiner";
import fieldsData       from './viewTableColumn.json';
import masterJSON       from './masterJson.json';
import contextJson      from './searchJson.json';
import DataTable from "../../../Component/DataTable/GenerateTable";
import {FormJSONCreateContext} from '../../../Component/FormJSONCreateContext';
//import Success Page  
import SuccessPage      from '../../../Component/SuccessPage.js';
//import for Navigation 
import {useNavigate}    from 'react-router-dom';


 
const apiContextObj=fieldsData.config;
//Flow Type
const contextObjective = "search";

function View() {
  const {useStyles} = ThemeControls;
    const classes=useStyles();
    const contextClasses = classes.topSpace_2;
  const [successRender,setSuccessRender] = useState(undefined);
  const [successPageData,setSuccessPageData] = useState(undefined);
  const [searchQuery, setSearchQuery] = useState("");
  const [alertData, setAlertData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [open, setOpen] = useState(false);

  //for navigation 
  let navigate = useNavigate();
  function renderSuccessPage(props){
    setSuccessPageData(props)
    setSuccessRender(1);
    //console.log('Success Rander is Rendering..')
  }
  function navigateToCreate(){
    navigate(successPageData.createLink)
    // handleClose();
    setSuccessRender(undefined);
    return null;
  }
  function navigateToView(){
     
    navigate(successPageData.viewLink);
    setSuccessRender(undefined);
  }
  React.useEffect(()=>{
  Object.keys(contextJson).forEach((key,index) =>{
    if(key!=="xioFEConfig"){
      contextJson[key].fields.map((field)=>{
        if(field.field_type==="custom"){
          field.field_value = "{}";
        } else if(field.field_type !== "hidden"&&field.field_default_value){
          field.field_value = field.field_default_value
          field.id = ""
        } else{
          field.field_value = "";
          field.id = "";
        }
        return field;
      });
    }else{
      if (key === "xioFEConfig") {
        if (key.config && key.config.apiContextSearch) {
          // setApiContextVar(key.config.apiContextSearch);
        }
      }
    }
  });
},[])

 const [apiPath,setApiPath] = React.useState("");
 
const apiString = (query) => {
  setApiPath(query);
};

  return (
  <FormJSONCreateContext.Provider value={{renderSuccessPage,masterJSON,contextJson}}>
    <div className={classes.main}> 
      {(successRender&&successPageData)?
          <SuccessPage
          policyName ={successPageData.policyName}
          actionName = {successPageData.actionName}
          createPolicyLink = {navigateToCreate}
          viewPolicyLink = {navigateToView}
          createButtonText = {successPageData.createButtonText}
          viewButtonText = {successPageData.viewButtonText}
          paragraphText = {successPageData.paragraphText}
        />
      :

       <>
        <div className={classes.formTabCard}>
        <div className={classes.searchForm}>
        <FormScopeDefiner value={{contextJson,apiContextObj,contextClasses,contextObjective}} apiString={apiString}/>
        </div>
        <DataTable setTableData={setFilteredData} searchQuery={searchQuery} viewJson={fieldsData} apiContextObj={apiContextObj} apiContext={apiPath} createJson={masterJSON} setAlertData={setAlertData}/>
        </div>
       </> 
              
      }
  </div>
</FormJSONCreateContext.Provider>
  );
}

export default View;
